module.exports = __webpack_public_path__ + "static/media/background-404-mobile.ef17a84f.jpg";